import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Assignment } from './assignment';
import { baseUrl, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';
import { Position } from './position'

@Injectable({
  providedIn: 'root'
})
export class PositionAssignmentsService {

  private url = baseUrl + gatewayFile;

  positions: Position[];

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getPositionAssignments(site: string, date: string): Observable<Position[]> {
    const url = `${this.url}`;
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'getPositionAssignments', item1: site, item2: date })
    .pipe(
      catchError(this.handleError('getPositionAssignments', []))
    );
  }

  removePositionAssignmentLast(id: any, posId: any, isLast: any): Observable<Assignment[]> {
    const url = `${this.url}`;
    return this.http.post<Assignment[]>(url, { token: localStorage.getItem('token'), function: 'removePositionAssignmentLast',
      item1: id, item2: posId, item3: isLast })
    .pipe(
      catchError(this.handleError('removePositionAssignment', []))
    );
  }

  removePositionAssignment(id: any): Observable<Assignment[]> {
    const url = `${this.url}`;
    return this.http.post<Assignment[]>(url, { token: localStorage.getItem('token'), function: 'removePositionAssignment', item1: id })
    .pipe(
      catchError(this.handleError('removePositionAssignment', []))
    );
  }

  removeFsPositionAssignment(id: any): Observable<Assignment[]> {
    const url = `${this.url}`;
    return this.http.post<Assignment[]>(url, { token: localStorage.getItem('token'), function: 'removePositionAssignment', item1: id })
    .pipe(
      catchError(this.handleError('removePositionAssignment', []))
    );
  }

  addPositionAssignment(positionId: string, type: string, inspId: string, agencyId: string, createdBy: string) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'addPositionAssignment',
      item1: positionId, item2: type, item3: inspId, item4: agencyId, item5: createdBy})
    .pipe(
      catchError(this.handleError('addPositionAssignment', []))
    );
  }

  updatePositionAssignment(positionId: string, type: string, inspId: string, agencyId: string, createdBy: string) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'updatePositionAssignment',
      item1: positionId, item2: type, item3: inspId, item4: agencyId, item5: createdBy})
    .pipe(
      catchError(this.handleError('addPositionAssignment', []))
    );
  }

  requestInspector(positionId: string, type: string, createdBy: string, reqInspId: any, reqName: any) {
    const url = `${this.url}`;
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'requestInspector', item1: positionId,
      item2: type, item3: createdBy, item4: reqInspId, item5: reqName })
    .pipe(
      catchError(this.handleError('requestInspector', []))
    );
  }

  getCurrentPositionAssignments(itemId: string): Observable<Assignment[]> {
    const url = `${this.url}`;
    return this.http.post<Assignment[]>(url, { token: localStorage.getItem('token'), function: 'getCurrentPositionAssignments', item1: itemId })
    .pipe(
      catchError(this.handleError('getCurrentPositionAssignments', []))
    );
  }

  getFutureAssignments(date: string): Observable<Position[]> {
    const url = `${this.url}`;
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'getFutureAssignments', item1: date })
    .pipe(
      catchError(this.handleError('getFutureAssignments', []))
    );
  }

  markOnSite(posId: string) {
    const url = `${this.url}`;
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'markOnSite', item1: posId })
    .pipe(
      catchError(this.handleError('markOnSite', []))
    );
  }

  markCovid(posId: string) {
    const url = `${this.url}`;
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'markCovid', item1: posId })
    .pipe(
      catchError(this.handleError('markCovid', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
